import { combineReducers } from 'redux';

import login from './login';
import register from './register';
import show from './show';

export default combineReducers({ login, register, show });
